import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router, Route, browserHistory, IndexRedirect } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { persistStore } from 'redux-persist';
import Container from './cms/Container';
// import DashboardContainer from './cms/dashboard/DashboardContainer';
import DashboardHome from './cms/dashboard/DashboardHome';
import Login from './cms/Login';
import EntryListBlitz from './cms/entry/EntryListBlitz';
import EntryListExternal from './cms/entry/EntryListExternal';
import SourceList from './cms/source/SourceList';
import SourceCreate from './cms/source/SourceCreate';
import SourceEdit from './cms/source/SourceEdit';
import PushNotifications from './cms/notifications/PushNotifications';
import Editor from './cms/form/editor/BlitzEditor';
import BlitzEntryCreate from './cms/entry/blitz/BlitzEntryCreate';
import BlitzEntryEdit from './cms/entry/blitz/BlitzEntryEdit';
import ExternalEntryCreate from './cms/entry/external/ExternalEntryCreate';
import ExternalEntryEdit from './cms/entry/external/ExternalEntryEdit';
import ChatRoomList from './cms/chat/ChatRoomList';
import ChatRoomEdit from './cms/chat/ChatRoomEdit';
import ChatRoomCreate from './cms/chat/ChatRoomCreate';
import AppTrackingDashboard from './cms/tracking/AppTrackingDashboard';
import AppTrackingList from './cms/tracking/AppTrackingList';
import AppTrackingFilter from './cms/tracking/AppTrackingFilter';
import EntrySchedule from './cms/entry/EntrySchedule';
import ChampionTips from './cms/tips/ChampionTips';
import BlitzAlert from './cms/alert/Alert';
import ChampionTipsItem from './cms/tips/ChampionTipsItem';
import TagEdit from './cms/tag/TagEdit';
import TagCreate from './cms/tag/TagCreate';
import TagList from './cms/tag/TagList';
import UserList from './cms/user/UserList';
import UserCreate from './cms/user/UserCreate';
import UserEdit from './cms/user/UserEdit';
import StatsQueryHome from './cms/stats/StatsQueryHome';
import BetaCreate from './cms/beta/BetaCreate';
import configureStore from './configureStore';
import { userIsLoggedIn } from './utils';
import BlitzAPI from './api/BlitzAPI';


export const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

export default class Root extends Component {
  constructor() {
    super();
    this.state = { rehydrated: false };
  }

  componentWillMount() {
    persistStore(store, { blacklist: ['routing'] }, () => {
      this.setState({ rehydrated: true });
    });
  }

  render() {
    if (!this.state.rehydrated) {
      return <div>Loading...</div>;
    }
    const redux = store.getState();
    if (redux.user && redux.user.profile.token) {
      BlitzAPI.setToken(redux.user.profile.token);
    }
    return (
      <Provider store={store}>
        <Router history={history}>
          <Route path="/login" component={Login} />
          <Route path="/editor" component={Editor} />
          <Route path="/" component={Container} onEnter={userIsLoggedIn(store)} >
            <IndexRedirect to="/entries/external" />
            {/*<IndexRoute component={EntryListExternal} />*/}
            <Route path="/entries/blitz" component={EntryListBlitz} />
            <Route path="/entries/blitz/create/:type" component={BlitzEntryCreate} />
            <Route path="/entries/blitz/:entryId" component={BlitzEntryEdit} />
            <Route path="/entries/external" component={EntryListExternal} />
            <Route path="/entries/external/create" component={ExternalEntryCreate} />
            <Route path="/entries/external/:entryId" component={ExternalEntryEdit} />
            <Route path="/entries/scheduled" component={EntrySchedule} />
            <Route path="/sources" component={SourceList} />
            <Route path="/sources/create" component={SourceCreate} />
            <Route path="/sources/:sourceId" component={SourceEdit} />
            <Route path="/chatrooms" component={ChatRoomList} />
            <Route path="/chatrooms/create" component={ChatRoomCreate} />
            <Route path="/chatrooms/:chatRoomId" component={ChatRoomEdit} />
            <Route path="/tags" component={TagList} />
            <Route path="/tags/create" component={TagCreate} />
            <Route path="/tags/:tagId" component={TagEdit} />
            <Route path="/pushnotifications/create" component={PushNotifications} />
            <Route path="/users" component={UserList} />
            <Route path="/users/create" component={UserCreate} />
            <Route path="/users/:userId" component={UserEdit} />
            <Route path="/stats" component={StatsQueryHome} />
            <Route path="/betausers" component={BetaCreate} />
            <Route path="/tracking" component={AppTrackingDashboard} />
            <Route path="/trackingfilter" component={AppTrackingFilter} />
            <Route path="/trackingusers" component={AppTrackingList} />
            <Route path="/championtips" component={ChampionTips} />
            <Route path="/BlitzAlert" component={BlitzAlert} />
            <Route path="/championtips/:id" component={ChampionTipsItem} />
            <Route path="/dashboard" component={DashboardHome} />
          </Route>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root.js